import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { blastKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useCreateBlast = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('blasts/create/'), body, additional),
        onSuccess: (response) => {
            queryClient.setQueryData(blastKeys.detail(response.data.blast_id), response);
            return queryClient.invalidateQueries({ queryKey: blastKeys.list() });
        }
    });
};
export default useCreateBlast;
